import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DefaultFormValueControl } from '@coin/shared/core/util-helpers';

@Component({
  selector: 'coin-v2-toggle',
  imports: [FormsModule, MatSlideToggleModule],
  templateUrl: './v2-toggle.component.html',
  styleUrls: ['./v2-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class V2ToggleComponent extends DefaultFormValueControl<boolean> {
  readonly color = input.required<ToggleColor>();
  readonly label = input<string>();
  readonly labelPosition = input<'before' | 'after'>('after');
}

export const TOGGLE_COLORS = ['purple', 'petrol'] as const;
export type ToggleColor = (typeof TOGGLE_COLORS)[number];
